import React, { Component} from 'react'
import { Link } from 'react-router-dom'
import {
    Card,
    CardBlock
} from 'reactstrap';
import moment from 'moment'
import 'moment/locale/es'


class CommentBox extends Component{
    render(){
        return(
            <Card className="casoCard">
                <CardBlock>
                    <div>
                        <span className="text-muted">Caso:</span> <b><Link to={`/casos/${this.props.casoId}`}>{this.props.caso}</Link></b>
                    </div>
                    <div className="block-with-text">
                        {this.props.text}
                    </div>
                    <div className="card-actions">
                    <span className="text-muted"><i className="fa fa-clock-o" /> {moment.parseZone(this.props.updatedAt).local().locale('es').format('D [de] MMM YYYY[,] H:mm')}</span>
                        <Link className="panel-block" to={`/casos/${this.props.casoId}#comments`}>
                            <a className="btn btn-primary float-md-right">Responder</a>
                        </Link>
                    </div>
                </CardBlock>
            </Card>
        )
    }
}
export default CommentBox


// WEBPACK FOOTER //
// ./resources/assets/js/components/dashboard/CommentBox.jsx